import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBF1 } from "../../../../../redux/app/crb/groups/crb-f";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBF1PreviewProps = OwnProps;
function CRBF1Preview(props: CRBF1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBF1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "I", 17, renderItem17()],
					[null, null, 17.1, renderItem17P1()],
					[null, null, 17.2, renderItem17P2()],
					[null, null, 18, renderItem18()],
					[null, null, 19, renderItem19()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem17() {
		if (crbRecord.item17.tanks.length > 0) {
			const totalQuantityDischarged = crbRecord.item17.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item17.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Quantity Discharged: {totalQuantityDischarged.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}

	function renderItem17P1() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item17P1.wereTankWashingDischargedDuringCleaning ? (
					<>Rate of Discharge: {crbRecord.item17P1.rateOfDischarge} M³/hr</>
				) : (
					"No"
				)}
			</h4>
		);
	}
	function renderItem17P2() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item17P2.wereTankWashingDischargedFromSlops ? (
					<>
						<p>
							Quantity Discharged: {crbRecord.item17P2.quantityDischarged} M³
						</p>
						<p>Rate of Discharge: {crbRecord.item17P2.rateOfDischarge} M³/hr</p>
					</>
				) : (
					"No"
				)}
			</h4>
		);
	}

	function renderItem18() {
		const { placeOfBallast } = crbRecord.item17P3;
		const { startDate, startTime, endDate, endTime } = crbRecord.item18;

		const startDateTimeLocal = `${startDate}T${startTime}:00${crbRecord.timeZone}`;
		const startUtcTime = moment.utc(startDateTimeLocal);

		const endDateTimeLocal = `${endDate}T${endTime}:00${crbRecord.timeZone}`;
		const endUtcTime = moment.utc(endDateTimeLocal);

		if (placeOfBallast.place === "AT_SEA") {
			return (
				<>
					<h4 className="font-medium uppercase">
						Time of Pumping Commenced: {startUtcTime.format("HH:mm")} hrs (UTC)
						({startTime} SMT)
					</h4>
					<h4 className="font-medium uppercase">
						Commenced Position: {placeOfBallast.startPosition.latitude} /{" "}
						{placeOfBallast.startPosition.longitude}
					</h4>
					<h4 className="font-medium uppercase">
						Time of Pumping Stopped: {endUtcTime.format("HH:mm")} hrs (UTC) (
						{endTime} SMT)
					</h4>
					<h4 className="font-medium uppercase">
						Stopped Position: {placeOfBallast.endPosition.latitude}/
						{placeOfBallast.endPosition.longitude}
					</h4>
				</>
			);
		}
	}

	function renderItem19() {
		return (
			<h4 className="font-medium uppercase">
				Ship's Speed during Discharge: {crbRecord.item19.speed} knots
			</h4>
		);
	}

	return renderMain();
}

export default CRBF1Preview;
